import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { EnumSection } from "../../generated/enums";

export const sectionToIcon: Record<EnumSection, IconProp> = {
  section_dashboard: "home",
  section_account: "user",
  section_accounts: "users",
  section_breeding: "building",
  section_breedings: "building",
  section_building: "building",
  section_breeding_building: "building",
  section_company: "briefcase",
  section_devices: "cogs",
  section_device: "cogs",
  section_my_device: "user",
  section_profile: "user",
  section_installer: "screwdriver-wrench",
  section_partnerships: "handshake",
  section_charts: "chart-area",
  section_history: "clock-rotate-left",
  section_regulators: "gauge",
  section_analysis: "chart-line",
  section_collaborators: "user-group",
};

export type DetailLevel = "mini" | "default" | "maxi";
